import stampit from 'stampit';
import ItemApiMixin from './item-api-mixin';



const InitiateProps = stampit({

  /**
   *
   * Creates google maps marker
   *
   * @memberOf module:MapApi/Google/MarkerApiFactory
   * @instance
   *
   * @ignore
   *
   * @param {object} opt object for initializing, see export below for all option parameters.
   * @param {object} opt.data
   * @param {object} [opt.options={}]  additional {@link https://developers.google.com/maps/documentation/javascript/3.exp/reference#MarkerOptions|marker options}
   *
   * @return {object} The instance on which this method was called
   */
  init: function init({data, options={}}, {instance, stamp, args}) {
    let markerLatLng,
      marker,
      mergedOptions,
      anchorPoint,
      defaultOptions;

    this.data = data;
    this.options = options;

    // Create latLng object
    markerLatLng = this.createLatLng(data.lat, data.lng);

    defaultOptions = {
      position: markerLatLng,
      map: data.map
    };

    // Create icon
    if (data.icon) {
      defaultOptions.icon = this.createIcon(data.icon);
    }

    // If icon data contains anchorPoint values for
    // correct positioning of infowindow, add value to marker options
    if (data.icon && data.icon.anchorPoint) {
      defaultOptions.anchorPoint =  new google.maps.Point(data.icon.anchorPoint[0], data.icon.anchorPoint[1]);
    }

    mergedOptions = Object.assign(defaultOptions, options);

    marker = new google.maps.Marker(mergedOptions);

    this.setItem(marker);

    return this;
  },

  properties: {
    data: {},
    options: {}
  }
});



const PublicMethods = stampit({
  methods: {

    /**
     *
     * Get marker lat/lng position object
     *
     * @memberOf module:MapApi/Google/MarkerApiFactory
     * @instance
     *
     * @return {object} google.maps.LatLng object instance
     */
    getPosition: function getPosition() {
      return this.getItem().getPosition();
    },

    /**
     *
     * Set position of marker using options object
     *
     * @memberOf module:MapApi/Google/MarkerApiFactory
     * @instance
     *
     * @param {object} options      lat/lng
     * @param {number} options.lat  latitude
     * @param {number} options.lng  longitude
     *
     * @return {object} The instance on which this method was called
     */
    setPosition: function setPosition(options) {
      let markerLatLng = this.createLatLng(options.lat, options.lng);

      this.getItem().setPosition(markerLatLng);

      return this;
    },

    /**
     *
     * Set icon of marker
     *
     * @memberOf module:MapApi/Google/MarkerApiFactory
     * @instance
     *
     * @param {object} options {@link MapApi/Google/ItemApiMixin#createIcon| see createIcon method for parameters}
     *
     * @return {object} The instance on which this method was called
     */
    setIcon: function setIcon(options) {
      let icon = this.createIcon(options);

      this.getItem().setIcon(icon);

      // If icon options contains anchorPoint values for
      // correct positioning of infowindow, set anchorPoint option of marker
      if (options.anchorPoint) {
        let anchorPoint = new google.maps.Point(options.anchorPoint[0], options.anchorPoint[1]);
        this.setOptions({'anchorPoint':anchorPoint});
      }

      return this;
    }
  }
});

const MarkerApiFactory = stampit(ItemApiMixin, InitiateProps, PublicMethods);

/**
 *
 * Google marker api factory created using stampit
 *
 * @module MapApi/Google/MarkerApiFactory
 * @mixes MapApi/Google/ItemApiMixin
 *
 * @param {object} opt               object for initializing. Note that opt.data keys are based on data-attribute names
 *                                   and are not the same as the actual google map option keys. The actual keys can be used
 *                                   via opt.options
 *
 * @param {object} opt.data
 * @param {number} opt.data.lat      latitude
 * @param {number} opt.data.lng      longitude
 * @param {object} opt.data.map      map to attach marker to, instance of google.maps.Map
 * @param {object} [opt.data.icon]   see {@link MapApi/Google/ItemApiMixin#createIcon|createIcon method}
 * @param {object} [opt.options={}]  additional {@link https://developers.google.com/maps/documentation/javascript/3.exp/reference#MarkerOptions|marker options},
 *                                   will override any existing options which were set via opt.data
 *
 * @example
 * import MarkerApiFactory from './map-api/google/marker-api-factory'
 *
 * // or MarkerApiFactory.create({data, options});
 * let markerHandler = MarkerApiFactory({
 *   data:{
 *     lat: markerData.lat,
 *     lng: markerData.lng,
 *     map: mapHandler.getMap(),
 *     icon: {
 *       anchor: [12, 40],
 *       anchorPoint: [0, -40],
 *       scaledSize: [24, 40],
 *       size: [48, 80],
 *       url: '/fileadmin/content/test-assets/maps/icons/marker-icon-2x.png'
 *     }
 *   }, options: {}
 * }).addInfoWindow(htmlString);
 */
export default MarkerApiFactory;



// WEBPACK FOOTER //
// ./src/frontend/js/map-api/google/marker-api-factory.js